module.exports = __webpack_public_path__ + "static/media/41-11.22835265.mp3";